
import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import CryptoJS from 'crypto-js';
import { RootState } from 'model';
import { useSelector, useDispatch } from 'react-redux';
import Icon from 'component/Icon';
import { ColorType } from 'component/IconWrapper';
import { LoadingStatus } from 'type/http';
import qs from 'qs';
import { getCsrfToken } from 'model/login';
import * as Api from 'api';
// Api.Pivot.unbindWxAccount(''); // 调试使用 删除已关联的账号，传入需要删除的openid

interface IProps {
  isWxRedirect: boolean;
  setIsWxRedirect: (val: boolean) => void;
}

const BODY_SIZE = '240px';
const QRCODE_SIZE = '180px';
const qrcodeCssStr = `html,
body {
  height: ${BODY_SIZE};
  margin: 0 !important;
  padding: 0 !important;
  background-color: #ffffff !important;
  line-height: 1 !important;
  overflow: hidden;
}
.title {
  display: none !important;
}

.impowerBox .title {
  font-size: 14px;
  /*color: #000000;*/
}

.impowerBox .info {
  width: ${BODY_SIZE};
}

.impowerBox .status_icon {
  display: none;
}
.impowerBox .status {text-align: center;} 

.js_wx_default_tip p {
  display: none;
}

.js_wx_default_tip::before {
  display: block;
  content: '微信扫码登录';
}

.impowerBox .qrcode {
  width: ${QRCODE_SIZE};
  height: ${QRCODE_SIZE};
  border: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}
`;

const wordArray = CryptoJS.enc.Utf8.parse(qrcodeCssStr);
const cssHref = 'data:text/css;base64,' + CryptoJS.enc.Base64.stringify(wordArray);

const _baseURL = 'https://open.weixin.qq.com/connect/qrconnect';

const LoginWithQRCodeWrapper: React.FC<IProps> = (props) => {
  const { isWxRedirect, setIsWxRedirect } = props;

  const dispatch = useDispatch();
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const csrfToken = useSelector((state: RootState) => state.login.csrfToken);
  const { loading } = useSelector((state: RootState) => state.login);
  const iframeEL = useRef<HTMLIFrameElement>(null);

  const handleGetUrl = () => {
    Api.Pivot.getWxLoginConfig().subscribe(config => {
      const params = {
        appid: config.wxAppId,
        scope: 'snsapi_login',
        redirect_uri: config.pivotServerUrl + config.wxRedirectUri,
        state: csrfToken,
        login_type: 'jssdk',
        href: cssHref
      };
      const _finalURL = `${_baseURL}?${qs.stringify(params)}`;

      setQrCodeUrl(_finalURL);
    }, err => {
      console.log(err);
    });
  };

  const handleRefresh = () => {
    if (!navigator.onLine) return;

    // if (loading === LoadingStatus.PENDING) return;

    if (!csrfToken) {
      // 多次调用 getCsrfToken 会产生大量的cookie，需要清理
      Api.Pivot.clearCookies();
      dispatch(getCsrfToken());
      return;
    }

    handleGetUrl();
  };

  const handleRefreshClick = () => {
    setIsWxRedirect(false);
    handleRefresh();
  };

  const handleOnline = () => {
    setIsOnline(true);
    handleRefresh();
  };

  const handleOffline = () => {
    setIsOnline(false);
  };

  useEffect(() => {
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    handleRefresh();
  }, [csrfToken]);

  const getIcon = () => {
    let type = 'iconfile_shuaxin_ic';
    let text = '';
    let colorType: ColorType = 'default';
    let rotate = false;
    if (!isOnline) {
      type = 'iconlogin_fail';
      text = '网络错误，稍后重试';
    } else if (loading === LoadingStatus.PENDING) {
      rotate = true;
      type = 'iconlogin_loading';
      text = isWxRedirect ? '正在获取用户信息' : '正在生成二维码';
    } else if (loading === LoadingStatus.REJECTED) {
      type = 'iconfile_shuaxin_ic';
      text = isWxRedirect ? '登录失败' : '二维码失效，点击刷新';
    } else if (loading === LoadingStatus.FULFILLED) {
      type = 'iconlogin_success';
      text = '登录成功';
      colorType = 'primary';
    }
    return <>
      <Icon type={ type } size="40" rotate={rotate} colorType={colorType} />
      <div className={styles.qrCodeImgTipText}>{ text }</div>
    </>;
  };

  return (<>
    <div className={styles.qrCodeWrapper}>
      <div className={styles.qrCodeTitle}>账号登录</div>
      <div className={styles.qrCodeImgWrapper}>
        {
          qrCodeUrl && isOnline && !isWxRedirect
            ? <iframe ref={iframeEL} className={styles.qrCodeImg} src={qrCodeUrl} sandbox="allow-scripts allow-top-navigation allow-same-origin"></iframe>
            : <div className={styles.qrCodeImgTip} onClick={handleRefreshClick}>
                { getIcon() }
              </div>
        }
      </div>
    </div>
  </>);
};

export default LoginWithQRCodeWrapper;
